import React, { useEffect, useState } from 'react';
import { PageContext } from './page-context';
import { getCurrentISOLanguage } from '../i18n/i18n';

export const withPageContext = (Page) => {
  return (pageProps) => {
    //   const [hydratedLang, setHydratedLang] = useState(null);
    //   useEffect(() => {
    //     setHydratedLang(getCurrentISOLanguage());
    //   }, []);
    //
    //   if (!hydratedLang) {
    //     return null;
    //   }

    return (
      <PageContext.Provider value={{ pageProps }}>
        <Page {...pageProps}></Page>
      </PageContext.Provider>
    );
  };
};
